module.exports = __webpack_public_path__ + "static/50a0b4f0-45c6-4d10-b4bb-d93b24b4a9d6-160.6a35f4af.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/objects/tricorn-sky-blue/50a0b4f0-45c6-4d10-b4bb-d93b24b4a9d6-160.jpg
// module id = 1272
// module chunks = 168707334958949